<template>
  <div class="content-container">
    <div class="table-wrapper">
      <div class="opration-wrapper">
        <span>{{ $t("message.userRecycleNotice") }}</span>
        <div style="float: right">
          <a-popconfirm
            placement="top"
            :ok-text="$t('actionTitles.yes')"
            :cancel-text="$t('actionTitles.no')"
            @confirm="batchRegain"
          >
            <template slot="title">
              {{ $t("message.reagainUserHint") }}
            </template>
            <a-button type="primary">{{ $t(`actionTitles.resume`) }}</a-button>
          </a-popconfirm>
          <a-popconfirm
            placement="top"
            :ok-text="$t('actionTitles.yes')"
            :cancel-text="$t('actionTitles.no')"
            @confirm="bacthDelete"
          >
            <template slot="title">
              {{ $t("message.batchDelUserHint") }}
            </template>
            <a-button style="color: red; margin-left: 10px">{{
              $t(`actionTitles.delete`)
            }}</a-button>
          </a-popconfirm>
        </div>
      </div>
      <a-form-model
        class="opration-wrapper"
        layout="inline"
        :model="searchForm"
      >
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.account.label')"
          prop="account"
        >
          <a-input
            v-model="searchForm.name"
            :placeholder="$t('message.checkInputHint')"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" html-type="submit" @click="search">{{
            $t(`actionTitles.submit`)
          }}</a-button>
          <a-button :style="{ marginLeft: '8px' }" @click="handleReset">{{
            $t(`actionTitles.clear`)
          }}</a-button>
        </a-form-model-item>
      </a-form-model>
      <clear-selected
        alert-type="error"
        :show="selectedRowKeys.length > 0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />

      <a-table
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :data-source="pageResult.data"
        :loading="loading"
        rowKey="id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <a-table-column
          key="phone"
          :title="$t('table.user.thead.account')"
          data-index="phone"
        />
        <a-table-column
          key="name"
          :title="$t('table.user.thead.nickname')"
          data-index="name"
        />
        <a-table-column
          key="parent_name"
          :title="$t('table.user.thead.superior')"
          data-index="parent_name"
          align="center"
        />
        <a-table-column
          key="total_works"
          :sorter="true"
          :title="$t('table.user.thead.worksCount')"
          data-index="total_works"
          align="center"
        />
        <a-table-column
          key="capacity"
          :sorter="true"
          :title="$t('table.user.thead.storage')"
          data-index="capacity"
          align="center"
        >
          <template slot-scope="text, record">
            <a-progress
              :percent="record.progress"
              :show-info="false"
              status="active"
            />
            <span>{{
              record.use_capacity + "G/" + record.capacity + "G"
            }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="expire_status"
          :title="$t('table.common.thead.state')"
          data-index="expire_status"
          align="center"
        >
          <template slot-scope="text, record">{{
            $t(`enum.expireStatus.${record.expire_status}`)
          }}</template>
        </a-table-column>
        <a-table-column
          key="update_time"
          :sorter="true"
          :title="$t('table.common.thead.updateTime')"
          data-index="update_time"
          align="center"
        >
          <template slot-scope="text, record">{{
            record.update_time
          }}</template>
        </a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a-popconfirm
                placement="top"
                :ok-text="$t('actionTitles.yes')"
                :cancel-text="$t('actionTitles.no')"
                @confirm="handleRegain(record.id)"
              >
                <template slot="title">
                  {{ $t("message.regainUser") }}
                </template>
                <a>{{ $t("actionTitles.resume") }}</a>
              </a-popconfirm>
              <a-divider type="vertical" />
              <!-- 刪除確認框-->
              <a-popconfirm
                placement="top"
                :ok-text="$t('actionTitles.yes')"
                :cancel-text="$t('actionTitles.no')"
                @confirm="handleDelete(record.id)"
              >
                <template slot="title">
                  {{ $t("message.delUserHint") }}
                </template>
                <a style="color: red">{{ $t("actionTitles.delete") }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import { queryRecycle, rserRestore, deleteUser } from "@/api/user";

export default {
  data() {
    return {
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
      },
      expand: false,
      selectedRowKeys: [],
      workList: [],
      pageResult: {},
      loading: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      searchForm: {},
    };
  },
  components: { ClearSelected },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    },
  },
  mounted() {
    this.loadData();
  },
  updated() {
    // console.log("updated");
  },
  methods: {
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      this.searchParam.type = 3;
      queryRecycle(this.searchParam)
        .then((ret) => {
          this.loading = false;
          this.pageResult = ret.data;
          this.pagination.total = ret.data.total;
          this.selectedRowKeys = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDelete(id) {
      deleteUser({ id: [id] }).then((res) => {
        this.loadData();
        this.$message.success(this.$i18n.t("message.deleteSuccess"));
      });
    },
    handleRegain(id) {
      rserRestore({ id: [id] }).then((res) => {
        this.loadData();
        this.$message.success(this.$i18n.t("message.regainSuccess"));
      });
    },
    bacthDelete() {
      if (this.selectedRowKeys.length > 0) {
        deleteUser({ id: this.selectedRowKeys }).then((res) => {
          this.loadData();
          this.$message.success(this.$i18n.t("message.deleteSuccess"));
        });
      } else {
        this.$message.warning(this.$i18n.t("message.selectHint"));
      }
    },
    batchRegain() {
      if (this.selectedRowKeys.length > 0) {
        rserRestore({ id: this.selectedRowKeys }).then((res) => {
          this.loadData();
          this.$message.success(this.$i18n.t("message.regainSuccess"));
        });
      } else {
        this.$message.warning(this.$i18n.t("message.selectHint"));
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";

        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
      }
      this.loadData();
    },
    handleReset() {
      this.pagination.current=1;
      this.searchForm = {};
      this.loadData();
    },
    search(){
      this.reset();
      this.loadData();
    },
    reset(){
      this.pagination.current=1;
    }
  },
};
</script>

<style lang="less" scoped>
</style>
